import { FC } from 'react'

import { PopoutRoot, popoutModel } from 'shared/ui/popout-root'
import { Popout } from 'shared/ui/popout'

import { Admission } from 'widgets/admission/ui'

export const Popouts: FC = () => {

    const popout = popoutModel.selectors.usePopout().data

    return (
        <PopoutRoot activePopout={popout}>
            <Popout
                key='admission'
                id='admission'
                fill='rgba(22, 30, 56, 0.56)'
                edge={12}
            >
                <Admission />
            </Popout>
        </PopoutRoot>
    )
}
